import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { store, key as storeKey } from './store/index'
import messages from '@intlify/unplugin-vue-i18n/messages'

import 'escs-frontend-library/style.css'

createApp(App)
	.use(store, storeKey)
	.use(router)
	.use(createPinia())
	.use(createI18n({
		legacy: false,
		messages
	}))
	.mount('#app')
